/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Model representing the data to be translated to an anchor html tag by the cliebnt
 */
export class HyperlinkModel { 
    /**
     * The url for the hyperlink, Href=\"\"
     */
    Href?: string;
    /**
     * The text to display for the hyperlink
     */
    LinkText?: string;
    /**
     * Whether to open a new page when the hyperlink is clicked, target=\"_blank\"
     */
    NewPage?: boolean;
    /**
     * Text to display when mouse hovers over hyperlink, title = \"\"
     */
    Title?: string;
}



// WEBPACK FOOTER //
// ./src/app/model/hyperlinkModel.ts